import { useState, useEffect } from 'react';

/**
 * Popover Component
 *
 * @param params { text }
 * @returns {JSX.Element}
 * @constructor
 */
const Popover = (params) => {
  const [text, setText] = useState('');

  /**
   * Init text.
   */
  useEffect(() => {
      setText(params.text);
  }, [params, text]);

  return (
    <span className="invite-link-popup" onClick={params.onClick}>{text}</span>
  )
}

export default Popover;
